module.exports = __webpack_public_path__ + "img/menu-bar-off_01.17284576.png";